import { render } from "./NewUserPage.vue?vue&type=template&id=210ebbca&scoped=true&ts=true"
import script from "./NewUserPage.vue?vue&type=script&lang=ts"
export * from "./NewUserPage.vue?vue&type=script&lang=ts"

import "./NewUserPage.vue?vue&type=style&index=0&id=210ebbca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210ebbca"]])

export default __exports__